import Active from '../components/common/Active';
import Revenue from '../components/common/Revenue';
import React from 'react';

const FinancialTracker = () => {
  return (
    <div className="px-4 py-6">
      <h2 className="text-xl font-bold mb-4">FinancialTracker</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Revenue />
        <Active />
      </div>
    </div>
  );
};

export default FinancialTracker;